import React from 'react'
import { Marker } from 'react-map-gl'
import { connect } from 'react-redux'
import * as constants from '../../../../constants'
import * as tools from '../../../../util/tools'
import config from '../../../../util/config'
import useStyles from './styles'

function MapBoxMarker(props) {
    const classes = useStyles()
    let markerType = props.markerType || constants.MAP_LOCATION_DEFAULT
    let markerClickStatus = props.markerClickStatus || false

    const onMarkerDragStart = (event) => {
        props.setLatitude(event.lngLat[1])
        props.setLongitude(event.lngLat[0])
    }

    const onMarkerDrag = (event) => {
        props.setLatitude(event.lngLat[1])
        props.setLongitude(event.lngLat[0])
    }

    const onMarkerDragEnd = (event) => {
        props.setLatitude(event.lngLat[1])
        props.setLongitude(event.lngLat[0])
    }

    const markerClickHandleFunc = () => {
        if (markerClickStatus) props.markerClick()
    }

    const validateLocation = () => (props.latitude !== '' && props.longitude !== '') ? true : false

    return (
        validateLocation() ?
            <Marker
                latitude={props.latitude}
                longitude={props.longitude}
                offsetTop={config.mapbox.offsetTop}
                offsetLeft={config.mapbox.offsetLeft}
                onDrag={(event) => onMarkerDrag(event)}
                onDragEnd={(event) => onMarkerDragEnd(event)}
                onDragStart={(event) => onMarkerDragStart(event)}
                captureClick={false}
            >
                <img
                    onClick={() => markerClickHandleFunc()}
                    src={tools.getMapIcon(markerType)}
                    className={markerType === constants.MAP_LOCATION_DEFAULT ? classes.pin : classes.pinCar}
                    alt={"Pido"} />
            </Marker> : ''
    );
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapBoxMarker)
